import Vue from "vue";
import VueI18n from "vue-i18n";
import ElementUI from "element-ui";
Vue.use(VueI18n);
const messages = {
    'zh-CN': require('./languages/zh-CN').default,
    'en': require('./languages/en').default,
    'ja': require('./languages/ja').default,
    'ru': require('./languages/ru').default,
    'es': require('./languages/es').default
};
const savedLang = localStorage.getItem('lang')
const validLangs = ['zh-CN', 'en', 'ja', 'ru', 'es']
const locale = validLangs.includes(savedLang) ? savedLang : 'zh-CN'

const i18n = new VueI18n({
    locale,
  messages,
  sync: true
});
Vue.use(ElementUI,{
    i18n: (key, value) => i18n.t(key, value)
});
export default i18n;